import { useRef } from 'react';

import classNames from 'classnames';

import type { NotificationPanelVariants } from '@helsenorge/designsystem-react/components/NotificationPanel';
import ServiceMessage from '@helsenorge/designsystem-react/components/ServiceMessage';
import Spacer from '@helsenorge/designsystem-react/components/Spacer';
import type { SpacerSizes } from '@helsenorge/designsystem-react/theme/spacers';

import type LanguageLocales from '@helsenorge/core-utils/constants/languages';
import type { WebCompProps } from '@helsenorge/framework-utils/web-component/register';

import { useAdditionalPageContent } from './use-additionalPageContent';

import styles from './styles.module.scss';

export interface DriftspanelWebCompProps extends WebCompProps {
  contentreference?: string;
  language?: LanguageLocales;
  emptyspacersize?: SpacerSizes;
  arialabel: string;
}

export const Driftspanel: React.FC<DriftspanelWebCompProps> = ({ contentreference, language, emptyspacersize, arialabel }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [meldinger, handleClosed] = useAdditionalPageContent(ref, contentreference, language);

  const driftsmeldinger = meldinger?.filter(m => m.messageType === 'driftsmelding' || !m.showAfterTitle);

  if (!driftsmeldinger || driftsmeldinger.length === 0) {
    return <div ref={ref}>{emptyspacersize ? <Spacer size={emptyspacersize} testId={`spacer${emptyspacersize}`} /> : null}</div>;
  }

  const driftspanelClassNames = classNames(styles.driftspanel, 'd-print-none');

  return (
    <div ref={ref} className={driftspanelClassNames} data-testid={'driftspanel'} role="region" aria-label={arialabel}>
      {driftsmeldinger.map(driftsmelding => (
        <ServiceMessage
          key={driftsmelding.id}
          label={driftsmelding.title}
          info={driftsmelding.introduction}
          extraInfo={driftsmelding.moreDetails}
          variant={driftsmelding.type.toLowerCase() as NotificationPanelVariants}
          dismissable={driftsmelding.messageType === 'driftsmelding' || !!driftsmelding.isClosable}
          onDismiss={(): void => handleClosed(driftsmelding)}
          closeBtnText={driftsmelding.dismissButtonText}
          testId="melding"
          urlTitle={driftsmelding.urlTitle}
          url={driftsmelding.url}
          target={driftsmelding.target}
          messageRole="none"
        />
      ))}
    </div>
  );
};

export default Driftspanel;
